import { render, staticRenderFns } from "./ContractUpdate.vue?vue&type=template&id=51476a5c&scoped=true&"
import script from "./ContractUpdate.vue?vue&type=script&lang=js&"
export * from "./ContractUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ContractUpdate.vue?vue&type=style&index=0&id=51476a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51476a5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
